import React, { useContext, useEffect, useRef, useState } from "react";
import { Card, Form, Input, Menu, Modal, Radio, Switch, Table, Tooltip, Typography, Upload } from "antd";
import EmployeeProfile from "./EmployeeProfile";
import "./UserProfile.css";
import NotificationLog from "./NotificationLog";
import ChangePassword from "./ChangePassword";
import { useLocation } from "react-router-dom";
import PaySlipUser from "./PaySlipUser";

const UserIndex = () => {

    const [selectedMenu, setSelectedMenu] = useState("profile");
    const location = useLocation();
    const { fromEdit, menu } = location.state || {};

    useEffect(() => {
        if (fromEdit) {
            setSelectedMenu("password")
        }
    }, [fromEdit])

    const renderContent = () => {
        switch (selectedMenu) {
            case "profile":
                return <EmployeeProfile />;
            case "notification":
                return <NotificationLog />;
            case "password":
                return <ChangePassword />;
            case "payslip":
                return <PaySlipUser />;
            default:
                return null;
        }
    };

    const [indicatorTop, setIndicatorTop] = useState(0);
    const [indicatorHeight, setIndicatorHeight] = useState(0);
    const menuRef = useRef(null);

    useEffect(() => {
        const activeItem = menuRef.current?.querySelector(".menu-item.active");
        if (activeItem) {
            setIndicatorTop(activeItem.offsetTop);
            setIndicatorHeight(activeItem.offsetHeight);
        }
    }, [selectedMenu]);

    return (
        <>
            <div className="flex user-profile h-[97%]">
                <div className=" w-2/12 h-[100%] bg-white rounded-l-lg">
                    <div className="menu-container rounded-l-lg" ref={menuRef}>
                        <div
                            className="active-indicator"
                            style={{
                                top: indicatorTop,
                                height: indicatorHeight,
                            }}
                        />
                        <div style={{ paddingLeft: "10px" }}
                            className={`menu-item ${selectedMenu === "profile" ? "active" : ""}`}
                            onClick={() => setSelectedMenu("profile")}
                        >
                            Profile
                        </div>
                        <div style={{ paddingLeft: "10px" }}
                            className={`menu-item ${selectedMenu === "notification" ? "active" : ""}`}
                            onClick={() => setSelectedMenu("notification")}
                        >
                            Notification Log
                        </div>
                        <div style={{ paddingLeft: "10px" }}
                            className={`menu-item ${selectedMenu === "password" ? "active" : ""}`}
                            onClick={() => setSelectedMenu("password")}
                        >
                            Password
                        </div>
                        <div style={{ paddingLeft: "10px" }}
                            className={`menu-item ${selectedMenu === "payslip" ? "active" : ""}`}
                            onClick={() => setSelectedMenu("payslip")}
                        >
                            PaySlip
                        </div>
                    </div>
                </div>
                <div style={{ height: "100%", width: "85%", marginLeft: "10px" }}>
                    {renderContent()}
                </div> 
            </div>
        </>
    );
}

export default UserIndex;